import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names with clsx + tailwind-merge.
 * Resolves conflicting utilities (e.g. cn('p-2', condition && 'p-4') → 'p-4').
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
